<template>
    <v-container fluid tag="section" class="users">
        <!------------------------ MODAL ------------------------>
        <modal-user></modal-user>

        <v-row class="h-100">
            <v-col class="col-sm-12 d-flex mt-3 flex-wrap users-wrapper">
                <v-progress-circular v-if="isLoading" size="40" indeterminate />
                <div
                    class="col-sm-6 col-md-4 col-lg-3 col-xl-2 users-card"
                    v-for="user in users"
                    v-bind:key="user.id"
                >
                    <base-material-card class="v-card-profile avatar" :avatar="avatar">
                        <v-card-text class="text-center">
                            <h4
                                class="display-2 font-weight-medium mb-2 text-overflow"
                                v-if="user.profile != null"
                            >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span class="text-overflow" v-on="on">
                                            {{ user.profile.last_name }} {{ user.profile.first_name }}
                                            <br />
                                            {{ user.profile.middle_name }}
                                        </span>
                                    </template>
                                    <span>
                                        {{ user.profile.last_name }} {{ user.profile.first_name }}
                                        <br />
                                        {{ user.profile.middle_name }}
                                    </span>
                                </v-tooltip>
                            </h4>

                            <p class="font-weight-regular d-flex justify-center align-center">
                                <span class="mr-2">
                                    <v-icon>mdi-email-outline</v-icon>
                                </span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span class="text-overflow" v-on="on">{{ user.email }}</span>
                                    </template>
                                    <span>{{ user.email }}</span>
                                </v-tooltip>
                            </p>
                            <p class="font-weight-regular d-flex justify-center align-center">
                                <span class="mr-2">
                                    <v-icon>mdi-phone-outline</v-icon>
                                </span>
                                <span class="mt-1">{{user.mobile_phone}}</span>
                            </p>
                            <v-btn
                                color="success"
                                rounded
                                class="mr-0"
                                @click="goToUserProfile(user)"
                            >Профиль</v-btn>
                        </v-card-text>
                    </base-material-card>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ModalUser from "./components/ModalUser.vue";
    import { mask } from "vue-the-mask";
    import { mapGetters } from "vuex";

    export default {
        name: "Users",

        components: { ModalUser },

        data: vm => ({
            avatar: require('../../../assets/img/users/avatar.png'),
            showUserModal: false
        }),

        computed: {
            ...mapGetters("users", [
                "users",
                "isLoading",
                "hasError",
                "error",
                "hasUsers"
            ])
        },

        created() {
            this.$store.dispatch("users/findAllUsers");
        },

        methods: {
            closeUserModal() {
                this.showUserModal = false;
            },
            goToUserProfile({ id }) {
                this.$router.push({ name: "EditUser", params: { id: id } });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .users {
        .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 5px;
            background-color: green;
        }
        &-wrapper {
            max-height: 250px;
            .users-card {
                display: flex;
                justify-content: center;
                .v-card-profile.v-card {
                    width: 100%;
                }
            }
        }
    }
</style>